// src/App.tsx
import React from 'react';
import AppRoutes from './app/router/routes';

function App() {
  return <AppRoutes />;
}

export default App;
